import UTIF from 'utif'
import { pdfjs } from 'react-pdf'
import { isPdf, isTiff } from './image-source'

// How many pages a dropped file has, read without rendering any of them; a photo is one page. Rejects when the
// browser can't read the file, which the caller treats as "unknown".
export const countPages = async (file) => {
  if (isPdf(file)) {
    const pdf = await pdfjs.getDocument({ data: new Uint8Array(await file.arrayBuffer()) }).promise
    const { numPages } = pdf
    pdf.destroy()
    return numPages
  }
  if (isTiff(file)) {
    return UTIF.decode(await file.arrayBuffer()).filter((ifd) => ifd.t256 && ifd.t257).length
  }
  return 1
}
